import { memo, ReactElement } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export interface SessionLogoutDialogProps {
  isOpen: boolean;
  onConfirmLogout: () => void;
  onCloseDialog: () => void;
}

export const SessionLogoutDialog = memo(function SessionLogoutDialog({
  isOpen,
  onConfirmLogout,
  onCloseDialog,
}: SessionLogoutDialogProps): ReactElement {
  return (
    <Dialog open={isOpen} onClose={onCloseDialog}>
      <DialogTitle>
        <Typography variant='h6' component='div'>
          Sitzung beenden
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body1'>Möchten Sie die Sitzung beenden?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseDialog} color='primary'>
          Abbrechen
        </Button>
        <Button onClick={onConfirmLogout} color='error' variant='contained'>
          Beenden
        </Button>
      </DialogActions>
    </Dialog>
  );
});
